;(function () {
  'use strict'

  angular
    .module('contrast.application-libraries')
    .factory(
      'appLibrariesService',
      function appLibrariesServiceFactory(ApplicationFactory, ServiceUtils) {
        'ngInject'

        var service = {
          getLibrariesStats: getLibrariesStats
        }

        function getLibrariesStats(appId) {
          return ApplicationFactory.getLibrariesStats(appId)
            .then(ServiceUtils.handleResolve('data.stats'))
            .catch(ServiceUtils.handleError)
        }

        return service
      }
    )
})()
